/**
 * Mirror of QueuePolling\RendererPollSleepCadence in
 * server/system/application/enums/queuepolling/RendererPollSleepCadence.php — both must be
 * kept in sync. Latency-sensitive upload workflows opt into FAST so the backend's default 2 s
 * renderer-poll sleep doesn't compound across the 6+ sequential renderer round-trips a single
 * image upload makes.
 */
export enum RendererPollSleepCadence {
  DEFAULT = 'default',
  FAST = 'fast',
}

export const RENDERER_POLL_SLEEP_CADENCE_FORM_FIELD = 'rendererPollSleepCadence';
